const DEVICE_KEY = 'cos_chat_device_id_v1';

export function getChatDeviceId() {
    let value = localStorage.getItem(DEVICE_KEY);
    if (!value) {
        value = crypto.randomUUID();
        localStorage.setItem(DEVICE_KEY, value);
    }
    return value;
}
